import React from 'react';
import { defaultComponents } from './index';
import { PopoverContentProps } from '../types';

const PopoverContent = ({
	components = {},
	steps,
	setCurrentStep,
	currentStep,
	transition,
	isHighlightingObserved,
	setIsOpen,
}: PopoverContentProps) => {
	const step = steps[currentStep];
	const { Content } = defaultComponents(components);

	return (
		<Content
			content={step?.content}
			setCurrentStep={setCurrentStep}
			currentStep={currentStep}
			transition={transition}
			isHighlightingObserved={isHighlightingObserved}
			setIsOpen={setIsOpen}
		/>
	);
};

export default PopoverContent;
